export default __webpack_public_path__ + "static/media/menu-bar.2654352e.svg";